import { useEffect } from 'react'
import type { PropsWithChildren } from 'react'

import { useRouter } from 'next/router'

import { useRolrSetup } from '../../hooks/rolr'

import type { RolrSetupStepNames } from '../../hooks/rolr/context'

export interface StepGuardProps extends PropsWithChildren {
  /**
   * Current step.
   */
  currentStep: RolrSetupStepNames
}

export const StepGuard: React.FC<StepGuardProps> = ({
  currentStep,
  children,
}) => {
  const router = useRouter()
  const [, { validateStepDependencies, areAllDependenciesValidForStep }] =
    useRolrSetup()

  useEffect(() => {
    validateStepDependencies(router.pathname)
  }, [router.pathname, validateStepDependencies])

  if (!areAllDependenciesValidForStep(currentStep)) {
    return null
  }

  return <>{children}</>
}
